// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListHubspotPipelinesQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  excludeIds: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;

export type ListHubspotPipelinesQuery = { __typename?: 'Query' } & {
  listHubspotPipelines: { __typename?: 'ListHubspotPipelines' } & Pick<Types.ListHubspotPipelines, 'totalCount'> & {
      items: Array<
        { __typename?: 'HubspotPipeline' } & Pick<
          Types.HubspotPipeline,
          'id' | 'name' | 'enabled' | 'useBIResultByDefault' | 'updatedAt'
        >
      >;
    };
};

export const ListHubspotPipelinesDocument = /*#__PURE__*/ gql`
    query ListHubspotPipelines($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $excludeIds: [ID!]) {
  listHubspotPipelines(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, excludeIds: $excludeIds}
  ) {
    items {
      id
      name
      enabled
      useBIResultByDefault
      updatedAt
    }
    totalCount
  }
}
    `;

/**
 * __useListHubspotPipelinesQuery__
 *
 * To run a query within a React component, call `useListHubspotPipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHubspotPipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHubspotPipelinesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      excludeIds: // value for 'excludeIds'
 *   },
 * });
 */
export function useListHubspotPipelinesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>(
    ListHubspotPipelinesDocument,
    options,
  );
}
export function useListHubspotPipelinesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>(
    ListHubspotPipelinesDocument,
    options,
  );
}
// @ts-expect-error
export function useListHubspotPipelinesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>;
export function useListHubspotPipelinesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListHubspotPipelinesQuery | undefined, ListHubspotPipelinesQueryVariables>;
export function useListHubspotPipelinesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListHubspotPipelinesQuery, ListHubspotPipelinesQueryVariables>(
    ListHubspotPipelinesDocument,
    options,
  );
}
export type ListHubspotPipelinesQueryHookResult = ReturnType<typeof useListHubspotPipelinesQuery>;
export type ListHubspotPipelinesLazyQueryHookResult = ReturnType<typeof useListHubspotPipelinesLazyQuery>;
export type ListHubspotPipelinesSuspenseQueryHookResult = ReturnType<typeof useListHubspotPipelinesSuspenseQuery>;
